// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".light[data-v-4215d0b8] {\n  color: gray;\n  font-weight: 300;\n}\n.image-preview[data-v-4215d0b8] {\n  padding: 12px;\n  max-width: 200px;\n}\n.img-upload-wrapper[data-v-4215d0b8] {\n  display: flex;\n  min-height: 100px;\n  align-items: center;\n  justify-content: center;\n}\n.img-upload-wrapper[data-v-4215d0b8],\ninput[type=file][data-v-4215d0b8] {\n  width: 400px;\n  max-width: 400px;\n  text-align: center;\n  background-color: #fafafa;\n}", ""]);
// Exports
module.exports = exports;
